/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Menu } from '@neo4j-ndl/react';
import { FileTag, ImageTag, MoreFiles, UserBubble } from '@neo4j-ndl/react/ai';
import {
  DocumentIconOutline,
  PhotoIconOutline,
  TableCellsIconOutline,
} from '@neo4j-ndl/react/icons';
import { useRef, useState } from 'react';

const Component = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement | null>(null);

  return (
    <div className="n-flex n-flex-coln-gap-token-64 n-w-full n-justify-end">
      <div className="n-flex n-flex-col n-gap-token-8 n-items-end">
        <MoreFiles
          count={3}
          isActive={isMenuOpen}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          ref={anchorRef}
        />
        <Menu
          isOpen={isMenuOpen}
          anchorRef={anchorRef}
          onClose={() => setIsMenuOpen(false)}
        >
          <Menu.Item
            leadingVisual={<DocumentIconOutline />}
            title="Gardening tips"
            description="PDF"
            onClick={() => alert('Gardening tips')}
          />
          <Menu.Item
            leadingVisual={<TableCellsIconOutline />}
            title="TvSeries"
            description="CSV"
            onClick={() => alert('TvSeries')}
          />
          <Menu.Item
            leadingVisual={<PhotoIconOutline />}
            title="Family photo"
            description="JPG"
            onClick={() => alert('Family photo')}
          />
        </Menu>
        <ImageTag
          src="https://plus.unsplash.com/premium_photo-1676496046182-356a6a0ed002?q=80&w=2952&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          alt="Landscape image"
          fileName="Landscape image"
          fileType="jpg"
        />
        <FileTag
          icon={<TableCellsIconOutline />}
          fileName="MoviesDecade"
          fileType="csv"
        />
        <FileTag
          icon={<DocumentIconOutline />}
          fileName="Science Fiction Bestsellers"
          fileType="pdf"
        />
        <UserBubble
          avatarProps={{
            name: 'KM',
            source:
              'https://media.istockphoto.com/id/1334716681/photo/a-smiling-man.jpg?s=612x612&w=0&k=20&c=U6rkSDpQMzkcJEqx2hAa63fNLIhqnZb31Xuc_QSi648=',
            type: 'image',
          }}
        >
          Can you analyse my data and tell me about...?
        </UserBubble>
      </div>
    </div>
  );
};

export default Component;
